import { BOLOGNA_ENV_URL } from '../constants/common';
import { getBaseURL } from '../environments/url-helpers';

export const isBolognaEnv = () => BOLOGNA_ENV_URL.includes(getBaseURL());
